export enum PbhRemoveReasonType {
  None = 0,
  Scheduled = 1,
  Unscheduled = 2,
  ServiceableReturn = 3,
  RejectedQuarantinedPart = 4,
  ShelfLifeExpiration = 5,
}

export const GetPbhRemoveReasonType = [
  // { Description: "None", Value: RemoveReasonType.None },
  { Description: "Scheduled", Value: PbhRemoveReasonType.Scheduled },
  { Description: "Unscheduled", Value: PbhRemoveReasonType.Unscheduled },
  { Description: "Serviceable Return", Value: PbhRemoveReasonType.ServiceableReturn },
  { Description: "Rejected/Quarantined Part", Value: PbhRemoveReasonType.RejectedQuarantinedPart },
  { Description: "Shelf Life Expiration", Value: PbhRemoveReasonType.ShelfLifeExpiration },
];
